module.exports = __webpack_public_path__ + "img/light-Path 14@3x.a74d3852.png";